import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import API from '../services/api';

const TIPO_COLOR = {
  vacaciones: { bg: '#E6F1FB', color: '#185FA5' },
  baja: { bg: '#FCEBEB', color: '#A32D2D' },
  permiso: { bg: '#F5EFD6', color: '#8B6914' },
  otro: { bg: '#f0f0ed', color: '#666' },
};
const ESTADO_COLOR = {
  pendiente: { bg: '#FFF8E6', color: '#B47B00' },
  aprobada: { bg: '#EAF3DE', color: '#3B6D11' },
  rechazada: { bg: '#FCEBEB', color: '#A32D2D' },
};

export default function AusenciaDetalle() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { usuario } = useAuth();
  const isAdmin = usuario?.rol === 'admin';
  const [ausencia, setAusencia] = useState(null);
  const [cargando, setCargando] = useState(true);
  const [editando, setEditando] = useState(false);
  const [form, setForm] = useState({});
  const [error, setError] = useState('');
  const [msg, setMsg] = useState('');

  useEffect(() => { cargar(); }, [id]);

  const cargar = async () => {
    setCargando(true);
    try {
      const res = await API.get('/ausencias/' + id);
      setAusencia(res.data);
      setForm({ tipo: res.data.tipo, motivo: res.data.motivo || '', justificante_url: res.data.justificante_url || '' });
    } catch(e) { console.error(e); }
    setCargando(false);
  };

  const aprobar = async (aprobado) => {
    await API.put('/ausencias/' + id + '/aprobar?aprobar=' + aprobado);
    setMsg(aprobado ? 'Ausencia aprobada' : 'Ausencia rechazada');
    cargar();
  };

  const guardarEdicion = async () => {
    setError('');
    try {
      await API.put('/ausencias/' + id, form);
      setEditando(false);
      setMsg('Cambios guardados');
      cargar();
    } catch(err) {
      setError(err.response?.data?.detail || 'Error al guardar');
    }
  };

  const eliminar = async () => {
    if (!window.confirm('¿Eliminar esta ausencia?')) return;
    await API.delete('/ausencias/' + id);
    navigate('/ausencias');
  };

  if (cargando) return <div style={s.loading}>Cargando...</div>;
  if (!ausencia) return <div style={s.loading}>Ausencia no encontrada</div>;

  return (
    <div style={s.page}>
      <div style={s.topbar}>
        <button onClick={() => navigate('/ausencias')} style={s.backBtn}>← Ausencias</button>
        <div style={{ display: 'flex', gap: 8 }}>
          {isAdmin && !editando && <button style={s.btnGhost} onClick={() => setEditando(true)}>Editar</button>}
          {isAdmin && editando && <>
            <button style={s.btnGhost} onClick={() => setEditando(false)}>Cancelar</button>
            <button style={s.btn} onClick={guardarEdicion}>Guardar cambios</button>
          </>}
          {isAdmin && <button style={s.btnDanger} onClick={eliminar}>Eliminar</button>}
        </div>
      </div>

      <div style={s.content}>
        {msg && <div style={s.msgBox}>{msg}</div>}
        {error && <div style={s.errorBox}>{error}</div>}

        <div style={s.grid}>
          <div style={s.card}>
            <div style={s.cardTitle}>Información</div>
            <div style={s.infoGrid}>
              <div style={s.infoItem}>
                <div style={s.infoLabel}>Empleado</div>
                <div style={s.infoValue}>{ausencia.empleado_nombre}</div>
              </div>
              <div style={s.infoItem}>
                <div style={s.infoLabel}>Tipo</div>
                {editando ? (
                  <select style={s.input} value={form.tipo} onChange={e => setForm({...form, tipo: e.target.value})}>
                    {['vacaciones','baja','permiso','otro'].map(t => <option key={t} value={t}>{t.charAt(0).toUpperCase()+t.slice(1)}</option>)}
                  </select>
                ) : (
                  <span style={{...s.pill, background: TIPO_COLOR[ausencia.tipo]?.bg, color: TIPO_COLOR[ausencia.tipo]?.color}}>{ausencia.tipo}</span>
                )}
              </div>
              <div style={s.infoItem}>
                <div style={s.infoLabel}>Fecha inicio</div>
                <div style={s.infoValue}>{new Date(ausencia.fecha_inicio).toLocaleDateString('es-ES', {weekday:'long', day:'numeric', month:'long', year:'numeric'})}</div>
              </div>
              <div style={s.infoItem}>
                <div style={s.infoLabel}>Fecha fin</div>
                <div style={s.infoValue}>{new Date(ausencia.fecha_fin).toLocaleDateString('es-ES', {weekday:'long', day:'numeric', month:'long', year:'numeric'})}</div>
              </div>
              <div style={s.infoItem}>
                <div style={s.infoLabel}>Días hábiles</div>
                <div style={s.infoValue}>{ausencia.dias || '—'}</div>
              </div>
              <div style={s.infoItem}>
                <div style={s.infoLabel}>Estado</div>
                <span style={{...s.pill, background: ESTADO_COLOR[ausencia.estado]?.bg, color: ESTADO_COLOR[ausencia.estado]?.color}}>{ausencia.estado}</span>
              </div>
              {ausencia.aprobada_por_nombre && (
                <div style={{...s.infoItem, gridColumn: "1 / -1"}}>
                  <div style={s.infoLabel}>Gestionado por</div>
                  <div style={s.infoValue}>{ausencia.aprobada_por_nombre}</div>
                </div>
              )}
            </div>
            <div style={{marginTop: 16}}>
              <div style={s.infoLabel}>Motivo</div>
              {editando ? (
                <input style={{...s.input, marginTop: 4}} value={form.motivo} onChange={e => setForm({...form, motivo: e.target.value})} placeholder="Opcional" />
              ) : (
                <div style={{fontSize: 14, color: ausencia.motivo ? '#1a1a1a' : '#aaa', marginTop: 4}}>{ausencia.motivo || 'Sin motivo indicado'}</div>
              )}
            </div>
            <div style={{marginTop: 16}}>
              <div style={s.infoLabel}>Justificante</div>
              {editando ? (
                <div>
                  <input style={{...s.input, marginTop: 4}} value={form.justificante_url} onChange={e => setForm({...form, justificante_url: e.target.value})} placeholder="https://..." />
                  <div style={{fontSize: 11, color: '#aaa', marginTop: 4}}>Sube el fichero a Google Drive o similar y pega el enlace</div>
                </div>
              ) : ausencia.justificante_url ? (
                <a href={ausencia.justificante_url} target="_blank" rel="noreferrer" style={{color: '#378ADD', fontSize: 14}}>Ver documento →</a>
              ) : (
                <div style={{fontSize: 14, color: '#aaa', marginTop: 4}}>Sin justificante adjunto</div>
              )}
            </div>
            {isAdmin && ausencia.estado === 'pendiente' && !editando && (
              <div style={{display: 'flex', gap: 8, marginTop: 24}}>
                <button style={{...s.btn, background: '#3B6D11', flex: 1}} onClick={() => aprobar(true)}>✓ Aprobar</button>
                <button style={{...s.btn, background: '#A32D2D', flex: 1}} onClick={() => aprobar(false)}>✕ Rechazar</button>
              </div>
            )}
          </div>

          <div style={s.card}>
            <div style={s.cardTitle}>Historial de cambios</div>
            {!ausencia.historial || ausencia.historial.length === 0 ? (
              <div style={{fontSize: 13, color: '#aaa', padding: '16px 0'}}>Sin actividad registrada</div>
            ) : (
              ausencia.historial.map((h, i) => (
                <div key={i} style={{padding: '12px 0', borderBottom: '0.5px solid #f0f0ed'}}>
                  <div style={{display: 'flex', justifyContent: 'space-between', marginBottom: 4}}>
                    <span style={{fontSize: 13, fontWeight: 500}}>{h.usuario}</span>
                    <span style={{fontSize: 11, color: '#aaa'}}>{new Date(h.fecha).toLocaleDateString('es-ES', {day:'numeric', month:'short', year:'numeric', hour:'2-digit', minute:'2-digit'})}</span>
                  </div>
                  <div style={{fontSize: 12, color: '#666'}}>
                    <span style={{background: '#f0f0ed', padding: '1px 6px', borderRadius: 4, marginRight: 6, fontSize: 11}}>{h.accion}</span>
                    {h.detalle || ''}
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

const s = {
  page: { display: 'flex', flexDirection: 'column', minHeight: '100vh', background: '#f5f5f3', fontFamily: '-apple-system, BlinkMacSystemFont, Inter, sans-serif' },
  loading: { display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', color: '#aaa', fontSize: 14 },
  topbar: { background: 'white', borderBottom: '0.5px solid #e0e0d8', padding: '0 24px', height: 48, display: 'flex', alignItems: 'center', justifyContent: 'space-between' },
  backBtn: { background: 'none', border: 'none', cursor: 'pointer', fontSize: 13, color: '#666', fontWeight: 500 },
  content: { padding: 24 },
  grid: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 },
  card: { background: 'white', border: '0.5px solid #e0e0d8', borderRadius: 12, padding: 24 },
  cardTitle: { fontSize: 13, fontWeight: 600, color: '#1a1a1a', marginBottom: 16, textTransform: 'uppercase', letterSpacing: '0.05em' },
  infoGrid: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 },
  infoItem: { background: '#f5f5f3', borderRadius: 8, padding: '10px 14px' },
  infoLabel: { fontSize: 11, color: '#aaa', marginBottom: 4, textTransform: 'uppercase', letterSpacing: '0.05em' },
  infoValue: { fontSize: 14, fontWeight: 500, color: '#1a1a1a' },
  pill: { fontSize: 11, padding: '2px 8px', borderRadius: 10, fontWeight: 500 },
  btn: { background: '#378ADD', color: 'white', border: 'none', borderRadius: 8, padding: '8px 14px', fontSize: 13, fontWeight: 500, cursor: 'pointer' },
  btnGhost: { background: 'white', color: '#666', border: '0.5px solid #d0d0c8', borderRadius: 8, padding: '8px 14px', fontSize: 13, cursor: 'pointer' },
  btnDanger: { background: 'white', color: '#A32D2D', border: '0.5px solid #A32D2D', borderRadius: 8, padding: '8px 14px', fontSize: 13, cursor: 'pointer' },
  msgBox: { background: '#EAF3DE', color: '#3B6D11', borderRadius: 8, padding: '10px 14px', fontSize: 13, marginBottom: 16 },
  errorBox: { background: '#FCEBEB', color: '#A32D2D', borderRadius: 8, padding: '10px 14px', fontSize: 13, marginBottom: 16 },
  input: { width: '100%', padding: '9px 12px', borderRadius: 8, border: '0.5px solid #d0d0c8', fontSize: 14, outline: 'none', boxSizing: 'border-box', background: 'white' },
};
